// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__P0tbM","ProjectSection":"Project_ProjectSection__A83KU"};